import React from "react";
import {
  Document,
  Font,
  Image,
  Link,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import Application from "../../../../../database/models/application-form/india/Application";
import ieee from "../../../../../shared/resources/india-logo.png";
import { TeamRole } from "../../../../../shared/constants/Constant";

interface IProps {
  data: Data;
}

interface Data {
  fileName: string;
  application: Application;
}

const Preview = (props: IProps) => {
  const { application, fileName } = props.data;
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.imageWrapper}>
          <Image style={styles.image} src={ieee} />
        </View>

        <Text style={styles.title}>IEEE Innovation Nation India</Text>
        <Text style={styles.subtitle}>Pre-Accelerator</Text>

        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Project/Product Name:{" "}
            <Text style={styles.answer}>{application.projectName}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Problem Statement (or what are you trying to achieve?)
          </Text>
          <Text style={styles.answer}>{application.problem}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What is unique about your Project/Product
          </Text>
          <Text style={styles.answer}>{application.unique}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>What stage you are at</Text>
          <Text style={styles.answer}>{application.stage}</Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            What is the progress so far?
            <Text style={styles.answer}>{application.progress}</Text>
          </Text>
        </View>

        {application.pitch !== "" && (
          <View style={styles.fieldWrapperTwoline}>
            <Text style={styles.question}>Link to the pitch?</Text>
            <Link src={application.pitch} style={styles.link}>
              {fileName}
            </Link>
          </View>
        )}
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            How much investment is required to create a first prototype that
            meets your objectives?
          </Text>
          <Text style={styles.answer}>{application.requiredInvensment}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            How much investment is done by your team so far, if any?{" "}
          </Text>
          <Text style={styles.answer}>{application.invesmentDone}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Expected time needed to implement a prototype
          </Text>
          <Text style={styles.answer}>{application.expectedTime}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Any Patent applied or will be applied{" "}
          </Text>
          <Text style={styles.answer}>{application.anyPatent}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Why do you want to be an entrepreneur? Please write not more than
            200 words, for each team member.{" "}
          </Text>
          <Text style={styles.answer}>{application.whyEntreprenur}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            How long have you been thinking of the idea you are proposing?{" "}
          </Text>
          <Text style={styles.answer}>{application.howLoongThinking}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What strengths does your team have that will help you in this
            journey?{" "}
          </Text>
          <Text style={styles.answer}>{application.strenghts}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Any course on entrepreneurship, business management that any team
            member has already taken?{" "}
          </Text>
          <Text style={styles.answer}>{application.anyCourse}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            How strong is your belief in your idea?{" "}
          </Text>
          <Text style={styles.answer}>{application.howStrong}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            Which entrepreneur do you admire the most? Why{" "}
          </Text>
          <Text style={styles.answer}>{application.admireEntreprenur}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What is your primary expectation of the program{" "}
          </Text>
          <Text style={styles.answer}>{application.primaryExpectation}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            I understand that this will be an additional effort beyond my
            regular academics{" "}
          </Text>
          <Text style={styles.answer}>
            {application.additionalEffort ? "Yes" : "No"}
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            I commit to completing the full program and attend all
            workshops/activities/courses
          </Text>
          <Text style={styles.answer}>
            {application.attendAllWorkshops ? "Yes" : "No"}
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            I confirm that I will pay the required enrolment fee if selected (Rs
            1000 / Rs 750 if a IEEE member in team/ Rs 500 if a TEMS member in
            team){" "}
          </Text>
          <Text style={styles.answer}>
            {application.payRequiredEnrolmentFee ? "Yes" : "No"}
          </Text>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `[${pageNumber}]`}
          fixed
        />
      </Page>
      <Page style={styles.body}>
        <Text style={styles.subHeader}>Team Info</Text>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>Team Name</Text>
          <Text style={styles.answer}>{application.teamName}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>Domain/Category</Text>
          <Text style={styles.answer}>{application.domain}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>College/University name</Text>
          <Text style={styles.answer}>{application.college}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>Faculty Mentor Name</Text>
          <Text style={styles.answer}>{application.mentorName}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>Faculty Mentor Email Id</Text>
          <Text style={styles.answer}>{application.mentorEmail}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>Faculty Mentor Contact No</Text>
          <Text style={styles.answer}>{application.mentorContact}</Text>
        </View>
        <Text style={styles.subHeader}>Personal Info</Text>
        <Text style={styles.subHeaderTwo}>Team leader details</Text>
        <View style={{ marginLeft: 20 }}>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Name :
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.fullName)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Year/semester of study:
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.yearOfStudy)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Email:
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.email)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Contact Number:{" "}
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.contact)}
              </Text>
            </Text>
          </View>
        </View>
        <View>
          {application.members
            .filter((member) => member.role === TeamRole.MEMBER)
            .map((member, index) => (
              <View key={index}>
                <Text style={styles.subHeaderTwo}>Team member {index + 1}</Text>
                <View style={{ marginLeft: 20 }}>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Name:
                      <Text style={styles.answer}>{member.fullName}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Year/semester of study:{" "}
                      <Text style={styles.answer}>{member.yearOfStudy}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Email: <Text style={styles.answer}>{member.email}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Contact Number:{" "}
                      <Text style={styles.answer}>{member.contact}</Text>
                    </Text>
                  </View>
                </View>
              </View>
            ))}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `[${pageNumber}]`}
          fixed
        />
      </Page>
    </Document>
  );
};

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 10,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    color: "#00629b",
    textAlign: "center",
    fontFamily: "Oswald",
  },
  subtitle: {
    fontSize: 12,
    textAlign: "center",
    color: "#00629b",
    marginBottom: 10,
    paddingBottom: 10,
    borderBottomColor: "#333",
    borderBottomWidth: 1,
    borderColor: "#00629b",
  },
  fieldWrapperInline: {
    flexDirection: "row",
    alignContent: "flex-start",
    flexShrink: 1,
    margin: 10,
  },
  fieldWrapperTwoline: {
    flexDirection: "column",
    margin: 10,
  },
  subHeader: {
    margin: 10,
    fontWeight: 900,
    fontSize: 16,
    fontFamily: "Times-Bold",
  },
  subHeaderTwo: {
    margin: 10,
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "Times-Bold",
  },
  question: {
    fontWeight: 900,
    fontSize: 12,
    fontFamily: "Times-Bold",
    marginRight: 5,
    marginBottom: 3,
  },
  answer: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    marginRight: 10,
    textAlign: "justify",
  },
  image: {
    width: 100,
    textAlign: "center",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  imageWrapper: {
    flexDirection: "row",
    justifyContent: "center",
  },
  link: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    textAlign: "justify",
    color: "blue",
    textDecoration: "underline",
  },
});

export default Preview;
